import { render, staticRenderFns } from "./MyCurOrder.vue?vue&type=template&id=0ef6730d&scoped=true&"
import script from "./MyCurOrder.vue?vue&type=script&lang=js&"
export * from "./MyCurOrder.vue?vue&type=script&lang=js&"
import style0 from "./MyCurOrder.vue?vue&type=style&index=0&id=0ef6730d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6730d",
  null
  
)

export default component.exports